import {
    attributesContainer,
    messageContainer,
    messageTime,
    speechBubble,
    speechBubbleContainer,
} from './styles/InfoMessage'
import {InfoMessageProps} from '../types'
import InfoMessageView from './InfoMessageView'
import React from 'react'
import {styled} from 'stitches/config'
import {useHideAgentInfoMessage} from 'hooks/infoMessage/useHideAgentInfoMessage'

const StyledMessageContainer = styled('div', messageContainer)
const StyledSpeechBubbleContainer = styled('div', {
    ...speechBubbleContainer,
    variants: {
        isChannel: {
            true: {
                '.compact &': {
                    '> div': {margin: 0},
                    // 'background': '$messageMetadataCompactBackground',
                    'borderRadius': '6px',
                    'padding': '5px',
                },
            },
        },
    },

})
const StyledSpeechBubble = styled('div', speechBubble)
const StyledTime = styled('time', messageTime, {
    alignSelf: 'flex-end',
    marginBottom: '2px',
})

const StyledAttributesContainer = styled('div', attributesContainer)

const InfoMessage = (props: InfoMessageProps): React.ReactElement | null => {
    const {
        message,
        time,
    } = props

    if (useHideAgentInfoMessage(message)) {
        return null
    }

    return (
        <StyledMessageContainer hidden={message.message_hidden}>
            <StyledSpeechBubbleContainer isChannel={message.message_type === 'ninchat.com/info/channel'}>
                <StyledSpeechBubble>
                    <StyledAttributesContainer>
                        <InfoMessageView {...props} />
                    </StyledAttributesContainer>
                    {message?.skipTime ? null : <StyledTime>{time}</StyledTime>}
                </StyledSpeechBubble>
            </StyledSpeechBubbleContainer>
        </StyledMessageContainer>
    )
}

export default InfoMessage
